import { render, staticRenderFns } from "./BillingGrowth.vue?vue&type=template&id=4dff897a"
import script from "./BillingGrowth.vue?vue&type=script&lang=js"
export * from "./BillingGrowth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports